<template>
  <v-dialog width="600" v-model="dialog">
    <v-card>
      <gg-toolbar @close="close">
        Delete zone record
      </gg-toolbar>

      <v-card-text>
        <p class="mb-1">Are you certain that you want to delete this record?</p>
      </v-card-text>
      <v-card-actions class="justify-end">
        <gg-btn secondary @click="close">
          Cancel
        </gg-btn>
        <gg-btn :loading="loading" @click="deleteZoneRecord">
          Delete
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'
import modalMixin from '@/mixins/modal'

export default {
  name: 'DeleteRecordModal',
  mixins: [modalMixin],
  props: {
    item: {
      required: true,
      validator (val) {
        return val === null || typeof val === 'object'
      }
    },
    domain: {
      type: String,
      required: true
    },
    username: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess']),
    async deleteZoneRecord () {
      this.loading = true
      let data = {}
      const _username = this.username || this.$route.query.user
      switch (this.item.type) {
        case 'MX':
          const mxInfo = await amapi.cpanel_uapi({
            uapi_module: 'Email',
            uapi_function: 'list_mxs',
            domain: this.domain,
            _username,
          })
          const mxRecord = mxInfo.data.find(mx => mx.mx == this.domain)
          const priority = mxRecord?.entries.find(mx => mx.mx == this.domain)?.priority || '0'
          data = {
            uapi_module: 'Email',
            uapi_function: 'delete_mx',
            domain: this.domain,
            exchanger: this.item.exchange,
            priority,
            _username,
          }
          break
        default:
          data = {
            api2_module: 'ZoneEdit',
            api2_method: 'remove_zone_record',
            domain: this.domain,
            line: this.item.line,
            _username,
          }
          break
      }

      try {
        switch (this.item.type) {
          case 'MX':
            await amapi.cpanel_uapi(data)
            break

          default:
            await amapi.cpanel_api2(data)
            break
        }
        this.reportSuccess(`You successfully deleted the ${this.item.type} record.`)
        this.loading = false
        this.close()
        this.$emit('action-completed')
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    }
  },
}
</script>
